module.exports = __webpack_public_path__ + "static/media/0.231094fd.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/0.png
// module id = 1113
// module chunks = 0